const cachedData = {};

export default async function getSalons(locale) {
  if (!cachedData[locale]?.length) {
    try {
      const response = await fetch(
        `/api/firebase/get-salons-by-locale?locale=${encodeURIComponent(locale)}`
      );
      const { data } = await response.json();
      cachedData[locale] = data || [];
    } catch (e) {
      return [];
    }
  }

  return cachedData[locale];
}
